import { Button } from "@/components/ui/button";
import { CheckCircle } from "@phosphor-icons/react";

export default function SignupSuccess({ isUpdating, onClose }) {
  return (
    <div className="p-10 text-center" data-testid="signup-success">
      <CheckCircle size={56} weight="duotone" className="mx-auto text-cvc-navy" />
      <h2 className="font-heading text-4xl text-cvc-navy mt-4">Thank you.</h2>
      <p className="font-body text-cvc-ink-soft mt-3 max-w-md mx-auto">
        {isUpdating
          ? "We've received your updated request. Jonathan will personally review the updated details and reach out within 1–2 business days."
          : "We've received your request. Jonathan will personally review your case and reach out within 1–2 business days to confirm whether you're a fit to begin — or what preparation steps would set you up for success first."}
      </p>
      <Button
        data-testid="signup-success-close"
        className="mt-8 bg-cvc-red hover:bg-cvc-red-deep text-white rounded-full px-8"
        onClick={onClose}
      >
        Close
      </Button>
    </div>
  );
}
